// extracted by mini-css-extract-plugin
export default {"divider":"FareFeatures-module__divider___BZdBR"};